'use client';

import Script from 'next/script';
import type { FC } from 'react';

export const OHeyFlowFormScript: FC = () => (
  <Script async defer src="https://assets.prd.heyflow.com/builder/widget/latest/webview.js" type="text/javascript" />
);
